// Audit Trail Log — registra CADA ação do auditor com timestamp
// Útil para auditorias 3ª parte como prova de diligência
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { buildAuditEvent, verifyAuditEventChain } from "../utils/auditEventContract";
import { persistAuditEvent } from "../services/auditEvents";


export const useAuditLogStore = create(persist(
  (set, get) => ({
    log: [],
    seq: 0,
    chainHeadHash: null,

    // Add entry to log (called from components)
    logAction: ({ action, module, detail, clauseRef, sessionId }) => {
      const prev = { seq: get().seq, hash: get().chainHeadHash };
      const event = buildAuditEvent({ action, module, detail, clauseRef, sessionId }, prev);
      void persistAuditEvent(event);
      set(s => ({
        log: [
          event,
          ...s.log,
        ].slice(0, 500), // keep last 500 entries
        seq: event.seq,
        chainHeadHash: event.hash,
      }));
    },

    // Filter log by module
    getByModule: (module) => get().log.filter(e => e.module === module),

    verifyIntegrity: () => {
      const ordered = [...get().log].reverse();
      return verifyAuditEventChain(ordered);
    },

    // Clear log
    clearLog: () => set({ log: [], seq: 0, chainHeadHash: null }),
  }),
  {
    name: "norm_audit_log",
    storage: createJSONStorage(() => localStorage),
  }
));

// Action type constants
export const LOG_ACTIONS = {
  CLAUSE_VIEW:    "consultou_clausula",
  TRAIL_EXPAND:   "expandiu_trilha",
  PHOTO_ANALYZE:  "analisou_foto",
  NC_DRAFT:       "gerou_nc",
  NC_EVALUATE:    "avaliou_ac",
  NC_GENERATE:    "gerou_exemplos_nc",
  MEETING_GEN:    "gerou_pauta",
  CHANGE_ANALYZE: "analisou_mudanca",
  AI_ANALYZE:     "analise_ia",
  SIM_COMPLETE:   "completou_simulacao",
  CHECKLIST_RATE: "avaliou_clausula",
  PDF_EXPORT:     "exportou_pdf",
  SESSION_CREATE: "criou_sessao",
};
